'use strict';

define('vb/action/actionChain',[], () => {
  /**
   * Base class for code-base action chain.
   * @category Action
   */
  class ActionChain {
    /**
     * Runs the action chain with the provided context and parameters.
     *
     * @async
     * @param {Object} context contains all the scopes accessible to the action chain,
     * @param {Object} params parameters to the action chain
     * @returns {Promise}
     */
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    async run(context, params) {
      throw new Error('Not implemented');
    }
  }

  return ActionChain;
});

